import React from 'react';

import { Select as AntDSelect, SelectProps } from 'antd';
import { OptionProps } from 'antd/lib/select';
import styled from 'styled-components';

const StyledSelect = styled(AntDSelect)`
  font-family: var(--font-regular);
  font-size: 14px;

  &.rectangular {
    .ant-select-selector {
      font-size: 14px;
      color: var(--text-primary);
      border-radius: 0px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      border: solid 1px var(--line-gray);
    }
  }
`;

type CustomSelectProps = SelectProps & {
  dataTestId?: string;
};

const Select = ({ dataTestId, ...props }: CustomSelectProps) => {
  return (
    <StyledSelect
      data-test-id={dataTestId}
      suffixIcon={<img src="/icons/dropdown-caret-down.svg" height={10} width={10} alt="down" />}
      {...props}
    />
  );
};

Select.Option = ({ ...props }: OptionProps) => <AntDSelect.Option {...props} />;

export default Select;
